import React from 'react';
import { Doughnut, Bar } from 'react-chartjs-2';

import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    BarElement,
    CategoryScale,
    LinearScale,
} from 'chart.js';

// Register required chart components in Chart.js
ChartJS.register(ArcElement, Tooltip, Legend, Title, BarElement, CategoryScale, LinearScale,);

const EnergyConsumtionGraph = () => {
    const data = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
        datasets: [
          {
            label: 'Energy Consumption',
            data: [10, 15, 7, -5, 20, 5, -3, 10],
            backgroundColor: '#31746b',
          },
          {
            label: 'Energy Generation',
            data: [8, 13, 9, 6, 18, 12, 7],
            backgroundColor: '#92b9b4',
          },
        ],
      };
    
      const options = {
        responsive: true,
        scales: {
          x: {
            beginAtZero: true,
          },
          y: {
            beginAtZero: false,
            min: -10,
            max: 25,
            ticks: {
              stepSize: 5,
            },
          },
        },
        plugins: {
          legend: {
            display: false, // Hide the legend as per your original code
            position: 'bottom',
          },
        },
      };
    return (

        <div className="pt-2 ">
            <div className="box bg-light p-2">
                <h6><b>Monthly Energy Consumption and Generation</b></h6>
                <div style={{width: '100%', height: 'auto'}}>
                <Bar data={data} options={options} />
                </div>
            </div>
        </div>

    )
}
export default EnergyConsumtionGraph;
